import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { Users, DollarSign, ArrowLeftRight, RefreshCw } from "lucide-react";
import * as tests from "./testDefinitions";

export const PartnersAffiliatesSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Partners & Affiliates</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={Users}
          iconColor="text-blue-600"
          title="Partner Management"
          tests={tests.partnersAffiliatesTests}
          results={testResults.partnersAffiliates}
        />
        <TestSubsection
          icon={DollarSign}
          iconColor="text-green-600"
          title="Earnings & Payment Splitting"
          tests={tests.partnerEarningsTests}
          results={testResults.partnerEarnings}
        />
      </CardContent>
    </Card>
  );
};
